import React from "react";
import * as S from "./AlertHistory.Style";

function AlertHistory({
  historyAlertActive,
  setHistoryAlertActive
}) {

  return (
    <S.AlertHistory>
      <div className="header">
        <div className="header__left">
          <i className="header__icon icon zaia-timeline"></i>
          <div className="header__title">Historial de cambios de pesados</div>
        </div>
        <div className="header__right">
          <button className="header__button-close"
            onClick={() => {
              setHistoryAlertActive(null);
            }}
          >
            Cerrar
          </button>
        </div>
      </div>
      <div className="alert-info">
        <div className="alert-info__data">
          <div className="alert-info__severity">Severe Alert</div>
          <div className="alert-info__type">
            <i className="alert-info__type-icon zaia-icono-sintomas"></i>
            <div className="alert-info__type-text">Sintomas</div>
          </div>
          <div className="alert-info__data">
            <i className="alert-info__data-icon zaia-icono-ayuda"></i>
            <div className="alert-info__data-text">Vomito muy severo</div>
          </div>
        </div>
        <div className="alert-info__date">
          Fecha {'12/12/2025 14:30'}
        </div>
      </div>
      <div className="changes-list">
        <div className="changes-list__header">
          <div className="changes-list__title">Fecha</div>
          <div className="changes-list__title">Autor y Cambio</div>
        </div>
        <div className="change">
          <div className="change__left">
            <div className="change__date">30 Diciembre 2024</div>
            <div className="change__time">19:20</div>
          </div>
          <div className="change__right">
            <div className="change__author">
              <img src={""} alt="" className="change__author-photo" />
              <div className="change__author-name">Juan Perez</div>
            </div>
            <div className="change__action">
              <div className="action">
                <i className="action__icon icon zaia-icono-ayuda"></i>
                <div className="action__text">
                  Alerta Gestionada
                </div>
              </div>
              <i className="arrow icon zaia-i-next-1"></i>
              <div className="action">
                <i className="action__icon icon zaia-icono-ayuda"></i>
                <div className="action__text">
                  Esto no es una alerta
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </S.AlertHistory>
  )
}


export default AlertHistory;